import cx from 'classnames'

import { UserProfileAdd } from 'blaze-ui/icons'
import { Pressable } from '@react-aria/interactions'

import Styles from './MobileHeader.module.scss'
import StepperStyles from 'components/Wizards/Stepper/Stepper.module.scss'
import { Tab } from '../../InviteTeam'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { MobileBackButton } from 'almanac-ui/Modal/MobileBackButton'

interface Props {
  currentTab: Tab
  setCurrentTab: (tab: Tab) => void
}
export const MobileHeader = ({ currentTab, setCurrentTab }: Props) => {
  const theme = useHeaderTheme()

  return (
    <div className={Styles.root} data-theme={theme}>
      <div className={Styles.topBarContainer}>
        <div />
        <div className={Styles.titleContainer}>
          {<UserProfileAdd size={20} color="var(--dark-100)" />}
          <h4 className={Styles.title}>Invite Team Members</h4>
        </div>
        <div className={Styles.cancelContainer}>
          <MobileBackButton>Close</MobileBackButton>
        </div>
      </div>
      <div className={Styles.stepperContainer}>
        {['email', 'link'].map((tab) => {
          const active = currentTab === tab

          return (
            <>
              <div className={StepperStyles.stepContainer}>
                <Pressable onPress={() => setCurrentTab(tab as Tab)}>
                  <div
                    className={cx(StepperStyles.step, Styles.step, {
                      [StepperStyles.active]: active,
                      [Styles.active]: active,
                    })}
                  >
                    Invite By {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </div>
                </Pressable>
                {!!active && (
                  <svg
                    className={StepperStyles.activeIndicator}
                    width="32"
                    height="7"
                    viewBox="0 0 32 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.8555 1.90485C13.7438 0.243858 16.572 0.24386 18.4603 1.90485L20.004 3.26278C22.7422 5.67142 26.2642 7 29.9111 7H32H0H0.404728C4.05159 7 7.57354 5.67142 10.3118 3.26277L10.6105 3L11.8555 1.90485Z"
                      fill="var(--default-bg)"
                    />
                  </svg>
                )}
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}
